import PropTypes from "prop-types";
import camelCase from "lodash-es/camelCase";
import classNames from "classnames";
import "./checkbox.scss";

/*
    Usage: <CheckBox className={<string>} label={<string>} value={<boolean>} onChange={<function(event)>} name={<string>} />
*/

export function CheckBox(props) {
    const handleChange = (e) => {
        props.onChange({ ...e, target: { ...e.target, name: props.name, value: !props.value } });
    };
    return (
        <div key={camelCase(props.label)} className={classNames("paz-react-checkbox", { [props.className]: props.className })} >
            <label htmlFor={camelCase(props.label)}>
                <input id={camelCase(props.label)} type="checkbox" name={props.name} value={props.value} checked={props.value} onChange={handleChange}/>{props.label}
            </label>
        </div>
    );
}

CheckBox.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

CheckBox.defaultProps = {
    className: "default"
};
